'use client'

interface SectionHeaderProps {
  number: string
  title: string | React.ReactNode
}

export default function SectionHeader({ number, title }: SectionHeaderProps) {
  return (
    <div className='relative mb-7 font-criteria text-lg font-medium md:text-[44px]'>
      <span className='text-6xl text-black/10 md:text-9xl'>{number}</span>
      <span className='absolute left-11 top-1/2 -translate-y-1/2 transform leading-none md:left-28 md:top-[60%]'>
        {title}
      </span>
    </div>
  )
}
